import { ApolloClient, createHttpLink, InMemoryCache, NetworkStatus } from '@apollo/client/core'
import { provideApolloClient } from '@vue/apollo-composable'

export const apolloClient = new ApolloClient({
  link: createHttpLink({
    // You should use an absolute URL here
    uri: '/deposit/api/graphql'
  }),
  cache: new InMemoryCache(),
  headers: {
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true
    }
  }
})

provideApolloClient(apolloClient)
